import * as React from 'react';
export const konbiniSvg = React.forwardRef(function konbiniSvgInner(
  props,
  ref,
) {
  return /*#__PURE__*/ React.createElement(
    'svg',
    {
      ...props,
      ref: ref,
    },
    /*#__PURE__*/ React.createElement('path', {
      fill: '#F5F6F8',
      d: 'M0 0h32v32H0z',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M12.087 13.493a2.783 2.783 0 0 1 1.45-2.333c.683-.5.9-.667.9-1.1 0-.433-.217-.733-.617-.733s-.667.3-.733.716H12.07a1.667 1.667 0 0 1 1.75-1.55c1.25 0 1.666.75 1.666 1.484 0 .733-.283 1.016-1.15 1.7-.6.416-.833.7-.916.916h2.267l-.134.9h-3.466Zm6.283 0v-1.1h-2.217v-.933l2.033-2.866h1.15v2.932h.583v.867h-.583v1.1h-.967Zm0-2.833V9.51c-.396.696-.83 1.37-1.3 2.016h1.282l.017-.866Z',
      fill: '#6C7688',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M21.002 7.66v6.666h-9.998V7.66h9.998Zm0-1.666h-9.998A1.666 1.666 0 0 0 9.337 7.66v6.666a1.666 1.666 0 0 0 1.667 1.666h9.998a1.667 1.667 0 0 0 1.667-1.666V7.66a1.667 1.667 0 0 0-1.667-1.666Zm-1.666 13.331v5H12.67v-5h6.666Zm0-1.666H12.67a1.666 1.666 0 0 0-1.666 1.666v5a1.666 1.666 0 0 0 1.666 1.666h6.666a1.666 1.666 0 0 0 1.667-1.666v-5a1.667 1.667 0 0 0-1.667-1.666Z',
      fill: '#6C7688',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M15.17 18.492h1.666v6.483H15.17v-6.483ZM7.371 12.66h3.383v3.332H7.371V12.66Zm0-3.333h3.15v1.7H7.37v-1.7Zm14.148 0h3.15v1.7h-3.15v-1.7Zm-.35 3.333h3.733v3.332h-3.733V12.66Z',
      fill: '#6C7688',
    }),
    /*#__PURE__*/ React.createElement('path', {
      d: 'M24.335 7.66h-3.333v1.667h3.333v14.998H7.671V9.327h3.333V7.66H7.67a1.666 1.666 0 0 0-1.667 1.667v14.998a1.667 1.667 0 0 0 1.667 1.666h16.664a1.666 1.666 0 0 0 1.667-1.666V9.327a1.666 1.666 0 0 0-1.667-1.667Z',
      fill: '#6C7688',
    }),
  );
});
konbiniSvg.defaultProps = {
  width: '32',
  height: '32',
  viewBox: '0 0 32 32',
  fill: 'none',
  xmlns: 'http://www.w3.org/2000/svg',
};
export var konbini = {
  category: 'brand',
  colorable: false,
  name: 'konbini',
  svg: konbiniSvg,
};
